import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./baseQuery";

// Dummy API (JSONPlaceholder)
export const authApi = createApi({
  reducerPath: "authApi ", // optional, defaults to 'api'
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    register: builder.mutation({
      query: (formDataObj) => {
        const formData = new FormData();
        for (const key in formDataObj) {
          formData.append(key, formDataObj[key]);
        }

        return {
          url: "/auth/register",
          method: "POST",
          body: formData,
        };
      },
    }),
    login: builder.mutation({
      query: (credentials) => ({
        url: "/auth/login",
        method: "POST",
        body: credentials,
      }),
    }),
    forgetPassword: builder.mutation({
      query: (credentials) => ({
        url: "/auth/forget-password",
        method: "POST",
        body: credentials,
      }),
    }),
    resetPassword: builder.mutation({
      query: (credentials) => ({
        url: "/auth/reset-password",
        method: "POST",
        body: credentials,
      }),
    }),
  }),
});

export const {
  useRegisterMutation,
  useLoginMutation,
  useForgetPasswordMutation,
  useResetPasswordMutation,
} = authApi;
